import { observable, action, runInAction } from 'mobx';

import AuthStore from './AuthStore';
import AuthZStore from './AuthZStore';
import ConfigStore from './ConfigStore';
import GoogleAnalyticsStore from './GoogleAnalyticsStore';
import LocalizationStore from './LocalizationStore';
import MessagesStore from './MessagesStore';
import SafetyStore from './SafetyStore';
import ObservationsStore from './ObservationsStore';
import EventsStore from './EventsStore';
import NotificationsStore from './NotificationsStore';

export default class RootStore {
  @observable ready = false;

  @action('Initialize root store')
  async init() {
    this.configStore = new ConfigStore();

    try {
      // Allow the config store to load before we initialize the other stores.
      await this.configStore.init();
    } catch (error) {
      // Config could not be loaded. We can't load the app.
      throw error;
    }

    this.authStore = new AuthStore(this);
    this.authZStore = new AuthZStore(this);
    this.googleAnalyticsStore = new GoogleAnalyticsStore(this);
    this.localizationStore = new LocalizationStore(this);
    this.messagesStore = new MessagesStore(this);
    this.safetyStore = new SafetyStore(this);
    this.observationsStore = new ObservationsStore(this);
    this.eventsStore = new EventsStore(this);
    this.notificationsStore = new NotificationsStore(this);
    [
      this.authStore,
      this.authZStore,
      this.googleAnalyticsStore,
      this.localizationStore,
      this.messagesStore,
      this.safetyStore,
      this.observationsStore,
      this.eventsStore,
      this.notificationsStore
    ].forEach(async store => {
      if (store.init) {
        await store.init();
      }
    });

    runInAction('Mark root store as ready', () => {
      this.ready = true;
    });
  }
}



// WEBPACK FOOTER //
// ./src/stores/RootStore.js